import { useQueryString, useSsoIncloud, BaseTitolo, BaseLink } from '@lucan/base-ui';
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from "react-router-dom";
import Layout from 'components/Layout';
import Loading from 'components/Loading';
import { useCheckDeda } from 'services/Network';
import { Alert } from '@mui/material';


export default function DedaPage({onComplete}) {
 const { cmd } = useParams();
 const { code, state } = useQueryString();
 const [ errore, setErrore] = useState(null)
 const { setToken } = useSsoIncloud()
 const history = useHistory();

 const {
		 inAttesaDelServer,
		 invia
	} = useCheckDeda({})

	useEffect(() => {
    const  run = async ()=> {
			const { ok, data, error:errorRichiesta} = await invia(cmd, state, code)
			if(ok && data.esito){
				setToken(data.data?.token)
				history.push('/')
			}else{
				setErrore(data?.messaggi[0]?.codice ?? "Errore di comunicazione")
			}
    }
		run()

		
	}, [cmd, state, code])

	

	return (
		<Layout>
      <Loading loading={inAttesaDelServer} />
			{!inAttesaDelServer && 
				<>
				
				{errore && <><BaseTitolo>Attenzione non è stato possibile autenticarsi</BaseTitolo><Alert
							severity='error' 
							style={{ textAlign: 'left' }}
							sx={{ mb: 2 }}
						>
						{errore}
						</Alert></>}
				<br />
				<BaseLink to={'/'} >Torna al login</BaseLink>
				</>
			}
		</Layout>
	);
};
